import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LegalLinks } from "@/components/LegalLinks";
import useLegalInfo from "@/hooks/useLegalInfo";

export function LegalLayout({ kicker, title, updated, children, testid }) {
  const { complete, loaded } = useLegalInfo();
  useEffect(() => { window.scrollTo(0, 0); document.title = `${title} · AutoPresupuestos Pro`; }, [title]);
  return (
    <div className="min-h-screen bg-white" data-testid={testid}>
      <header className="border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/" className="font-display font-extrabold text-xl tracking-tight">AutoPresupuestos<span className="text-orange-600">.</span></Link>
          <Link to="/" className="text-sm font-semibold text-slate-600 hover:text-slate-900 inline-flex items-center gap-1" data-testid="legal-back-home">
            <ArrowLeft className="w-4 h-4" /> Volver
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-12 sm:py-16">
        <div className="kbar">{kicker}</div>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tight mt-3">{title}</h1>
        <p className="text-sm text-slate-500 mt-3">Última actualización: {updated}</p>
        {loaded && !complete && <div className="mt-6 p-4 border-l-4 border-orange-600 bg-orange-50 text-sm text-orange-900" data-testid="legal-placeholder-note">
          Los campos entre corchetes (p. ej. [NOMBRE EMPRESA], [NIF], [DIRECCIÓN], [EMAIL]) deben sustituirse por los datos reales del responsable (Admin → Cumplimiento legal).
        </div>}
        <article className="legal-prose mt-10 space-y-8 text-slate-700 leading-relaxed">{children}</article>
      </main>
      <footer className="border-t border-slate-200 py-8">
        <div className="max-w-3xl mx-auto px-5 text-sm text-slate-500 flex flex-wrap items-center justify-between gap-3">
          <span>© 2026 AutoPresupuestos Pro</span>
          <LegalLinks className="flex flex-wrap gap-4" itemClass="hover:text-slate-900" />
        </div>
      </footer>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display font-bold text-lg md:text-lg text-slate-900 mb-3">{title}</h2>
      <div className="space-y-3 text-sm sm:text-base">{children}</div>
    </section>
  );
}

export function KV({ rows }) {
  return (
    <dl className="border border-slate-200 divide-y divide-slate-200 text-sm">
      {rows.map(([k, v]) => (
        <div key={k} className="grid grid-cols-3 gap-3 p-3">
          <dt className="font-bold text-slate-900">{k}</dt>
          <dd className="col-span-2">{v}</dd>
        </div>
      ))}
    </dl>
  );
}
